import axios from "axios";
import { INurturing, NurturingFilters, NurturingStats, INurturingEvent } from "./nurturing";
import env from "../variables/config";

axios.defaults.baseURL = env.apiUrl;

const config = () => ({
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}` }
});

// Get all nurturings
export const getNurturings = async (filters?: NurturingFilters & { page?: number; limit?: number }) => {
    const searchParams = new URLSearchParams();
    
    if (filters?.type) searchParams.append("type", filters.type);
    if (filters?.status) searchParams.append("status", filters.status);
    if (filters?.priority) searchParams.append("priority", filters.priority);
    if (filters?.tags) filters.tags.forEach(tag => searchParams.append("tags", tag));
    if (filters?.minAlerts) searchParams.append("minAlerts", String(filters.minAlerts));
    if (filters?.search) searchParams.append("search", filters.search);
    if (filters?.sortBy) searchParams.append("sortBy", filters.sortBy);
    if (filters?.order) searchParams.append("order", filters.order);
    if (filters?.page) searchParams.append("page", String(filters.page));
    if (filters?.limit) searchParams.append("limit", String(filters.limit));
    
    const url = `/nurturings${searchParams.toString() ? `?${searchParams.toString()}` : ""}`;
    
    const response = await axios.get(url, config());
    return response.data;
};

// Get nurturing statistics
export const getNurturingStats = async (): Promise<NurturingStats> => {
    const response = await axios.get(`/nurturings/stats/summary`, config());
    return response.data;
};

// Get a specific nurturing
export const getNurturing = async (id: string): Promise<INurturing> => {
    const response = await axios.get(`/nurturings/${id}`, config());
    return response.data;
};

// Create a new nurturing
export const createNurturing = async (nurturing: Partial<INurturing>): Promise<INurturing> => {
    const response = await axios.post(`/nurturings`, nurturing, config());
    return response.data;
};

// Update a nurturing
export const updateNurturing = async (id: string, nurturing: Partial<INurturing>): Promise<INurturing> => {
    const response = await axios.put(`/nurturings/${id}`, nurturing, config());
    return response.data;
};

// Delete a nurturing
export const deleteNurturing = async (id: string) => {
    const response = await axios.delete(`/nurturings/${id}`, config());
    return response.data;
};

// Add an event to a nurturing
export const addNurturingEvent = async (id: string, event: Partial<INurturingEvent>): Promise<{ message: string; nurturing: INurturing }> => {
    const response = await axios.post(`/nurturings/${id}/events`, event, config());
    return response.data;
};

// Toggle nurturing status (active/paused)
export const toggleNurturingStatus = async (id: string): Promise<{ message: string; nurturing: INurturing }> => {
    const response = await axios.patch(`/nurturings/${id}/toggle-status`, {}, config());
    return response.data;
};

// Search companies for auto-suggestion
export const searchCompanies = async (query: string): Promise<{ data: any[] }> => {
    const response = await axios.get(`/nurturings/search/companies?query=${encodeURIComponent(query)}`, config());
    return response.data;
};
